import { VERSION } from './artwork/const'
import main from './artwork/main'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'

serviceWorkerRegistration.register()

console.log(`Anni (unravel) v${VERSION}`)

main()

const exportSomething = true

document.addEventListener('click', function () {
  document.body.requestPointerLock()
})

export default exportSomething
